/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationDetailModel
 */
export interface NotificationDetailModel {
    /**
     * 
     * @type {number}
     * @memberof NotificationDetailModel
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationDetailModel
     */
    status?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationDetailModel
     */
    isRead?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NotificationDetailModel
     */
    receiverRole?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NotificationDetailModel
     */
    receiverId?: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationDetailModel
     */
    requestId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NotificationDetailModel
     */
    offerId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NotificationDetailModel
     */
    machineId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationDetailModel
     */
    from?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationDetailModel
     */
    text?: string | null;
}

export function NotificationDetailModelFromJSON(json: any): NotificationDetailModel {
    return NotificationDetailModelFromJSONTyped(json, false);
}

export function NotificationDetailModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationDetailModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'isRead': !exists(json, 'isRead') ? undefined : json['isRead'],
        'receiverRole': !exists(json, 'receiverRole') ? undefined : json['receiverRole'],
        'receiverId': !exists(json, 'receiverId') ? undefined : json['receiverId'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'offerId': !exists(json, 'offerId') ? undefined : json['offerId'],
        'machineId': !exists(json, 'machineId') ? undefined : json['machineId'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'text': !exists(json, 'text') ? undefined : json['text'],
    };
}

export function NotificationDetailModelToJSON(value?: NotificationDetailModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'status': value.status,
        'isRead': value.isRead,
        'receiverRole': value.receiverRole,
        'receiverId': value.receiverId,
        'requestId': value.requestId,
        'offerId': value.offerId,
        'machineId': value.machineId,
        'from': value.from,
        'text': value.text,
    };
}

